// Quantity stepper — wraps a number input with -/+ buttons.
// Markup:
//   <quantity-input>
//     <button data-quantity-minus>-</button>
//     <input type="number" min="1" value="1">
//     <button data-quantity-plus>+</button>
//   </quantity-input>
if (!customElements.get("quantity-input")) {
  customElements.define(
    "quantity-input",
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("input[type='number']");
        this.minus = this.querySelector("[data-quantity-minus]");
        this.plus = this.querySelector("[data-quantity-plus]");
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.minus?.addEventListener("click", this.onClick);
        this.plus?.addEventListener("click", this.onClick);
      }

      disconnectedCallback() {
        this.minus?.removeEventListener("click", this.onClick);
        this.plus?.removeEventListener("click", this.onClick);
      }

      onClick(event) {
        if (!this.input) return;
        const step = event.currentTarget === this.plus ? 1 : -1;
        const min = parseInt(this.input.min, 10) || 1;
        const current = parseInt(this.input.value, 10) || min;
        const next = Math.max(min, current + step);
        if (next === current) return;
        this.input.value = next;
        this.input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    },
  );
}
